var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userForm"},[_c('AppForm',{ref:"form",attrs:{"cancenlMargin":"","formStyle":"default","fields":_vm.formFields,"rules":_vm.rules,"defaultValues":_vm.defaultValues},on:{"cancel":_vm.cancel,"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }